<template>
	<div class="development-plan-container">
		<div class="development-plan-header">
			<h2 class="development-plan-title" :style="`color:${$appColors.primary}`">
				Plan de Desarrollo por Competencia
			</h2>
			<p-button
				type="primary"
				@click="goBack"
				class="back-button"
			>
				Atrás
			</p-button>
		</div>

		<p-card class="development-plan-content">
			<div class="development-plan-info">
				<text-list-sortable
					title="Actividades"
					:items="activities"
					section-type="activity"
					:record-id="recordId"
					@update:items="updateActivities"
					@save-section="saveSection"
				></text-list-sortable>

				<text-list-sortable
					title="Lecturas"
					:items="readings"
					section-type="reading"
					:record-id="recordId"
					@update:items="updateReadings"
					@save-section="saveSection"
				></text-list-sortable>

				<text-list-sortable
					title="Géneros Cinematográficos"
					:items="others"
					section-type="filmGenre"
					:record-id="recordId"
					@update:items="updateOthers"
					@save-section="saveSection"
				></text-list-sortable>
			</div>
		</p-card>
	</div>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PButton from '@/modules/shared/components/ui/p-button';
import TextListSortable from '@/components/configuration/development-plan/text-list-sortable';

function created() {
	this.loadData();
}

async function loadData() {
	try {
		const { data: response } = await this.$http.get(`competence-indicator/${this.nodeId}`);

		if (response) {
			this.activities = response.activity || [];
			this.readings = response.reading || [];
			this.others = response.filmGenre || [];
			this.recordId = response.id || null;
		}
	} catch (error) {
		this.showGenericError();
	}
}

function updateActivities(items) {
	this.activities = items;
}

function updateReadings(items) {
	this.readings = items;
}

function updateOthers(items) {
	this.others = items;
}

async function saveSection(sectionData) {
	try {
		const body = {
			hierarchyId: this.nodeId,
			toolId: this.toolIdParam,
		};
		body[sectionData.type] = sectionData.items;

		if (this.recordId) {
			delete body.hierarchyId;
			delete body.toolId;
			await this.$http.patch(`competence-indicator/${this.recordId}`, body);
			this.showNotification('Sección actualizada correctamente');
		} else {
			await this.$http.post('competence-indicator', body);
			this.showNotification('Sección creada correctamente');
		}
		await this.loadData();
	} catch (error) {
		this.showGenericError();
	}
}

function data() {
	return {
		activities: [],
		readings: [],
		others: [],
		recordId: null,
	};
}

export default {
	name: 'page-development-plan-by-competence',
	components: {
		PCard,
		PButton,
		TextListSortable,
	},
	created,
	data,
	computed: {
		nodeId() {
			return this.$route.params.nodeId;
		},
		toolCode() {
			return this.$route.params.toolCode;
		},
		toolIdParam() {
			return this.$route.params.toolId;
		},
	},
	methods: {
		loadData,
		updateActivities,
		updateReadings,
		updateOthers,
		saveSection,
		goBack() {
			this.$router.go(-1);
		},
	},
};
</script>

<style lang="scss" scoped>
.development-plan-container {
	padding: 20px;

	.development-plan-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;

		.development-plan-title {
			font-size: 24px;
			font-family: font(bold);
			margin: 0;
		}
	}

	.development-plan-content {
		min-height: 400px;

		.development-plan-info {
			padding: 20px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/configuration/page-development-plan-by-competence.vue